const statusColorMap = {
  1: '#2196F3',
  2: '#FF9800',
  3: '#F44336',
  4: '#4CAF50',
  5: '#E91E63',
  6: '#9E9E9E',
  7: '#FF5722',
  8: '#FFC107',
  9: '#4CAF50',
  10: '#F44336',
  11: '#03A9F4',
  12: '#1976D2',
  13: '#795548',
  14: '#E91E63',
  15: '#FFB300',
  16: '#03A9F4',
  17: '#00C853',
  18: '#1976D2',
  19: '#9C27B0',
  20: '#795548',
  21: '#00BCD4',
  22: '#00ACC1',
  23: '#0097A7',
  24: '#673AB7',
  25: '#00BCD4',
  32: '#512DA8',
  33: '#0097A7',
  34: '#0288D1',
  35: '#FFB74D',
  36: '#F9A825',
  37: '#66BB6A',
  38: '#FFA726',
  39: '#EF5350',
  40: '#7E57C2',
  47: '#26C6DA',
  48: '#42A5F5',
  49: '#5C6BC0',
  50: '#5C6BC0',
  51: '#26A69A',
  52: '#AB47BC',
  53: '#EF5350',
  54: '#F44336',
  55: '#00ACC1',
  56: '#E53935',
  57: '#D32F2F',
  58: '#C62828',
  59: '#B71C1C',
  60: '#81C784',
  61: '#66BB6A',
  62: '#4CAF50',
};

export const getStatusColor = (statusId) => {
  const id = typeof statusId === 'string' ? parseInt(statusId, 10) : statusId;
  return statusColorMap[id] || '#9E9E9E';
};

export default statusColorMap;
